import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {AuthUser, UserCredentials} from './auth.model';

@Injectable()
export class AuthService {
  constructor(
    private http: HttpClient
  ) {}

  login(creds: UserCredentials): Observable<AuthUser> {
    return this.http.post('/Login', {creds}) as Observable<AuthUser>;
  }
}
